import { SerializedData, Store } from "bernie-core";
import { RateCalendarStore } from "stores/rateCalendar/RateCalendarStore";
import { observable } from "mobx";
import { DatePickerContent } from "src/components/flexComponents/WizardHotelPWA/typings";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { RateCalendarFooterProps } from "components/flexComponents/WizardHotelPWA/components/RateCalendarFooter";
import { ExtendedContextStore, FlexContext } from "typings/flexFramework/FlexDefinitions";
import { FlexModuleModelStore } from "stores/FlexModuleModelStore";

export class ClientRateCalendarStore extends Store implements RateCalendarStore {
  @observable
  public experimentBucket: number;

  @observable
  public isExperimentEnabled: boolean;

  @observable
  public datePickerContent: DatePickerContent;

  @observable
  public footerHtmlProps: RateCalendarFooterProps;

  @observable
  public footerText: string;

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  setup(
    flexContext: FlexContext,
    contextStore: ExtendedContextStore,
    flexModuleModelStore: FlexModuleModelStore
  ): void {
    // does nothing
  }

  setFooterHtmlProps(): void {
    // does nothing
  }

  setFooterText(): void {
    // does nothing
  }
}
